import { getTarget, SCROLL_TO_TARGET_MOBILE_TAB_BAR } from '@/helpers/scrollTo';
import { useMotionValue } from 'motion/react';
import { useEffect } from 'react';
export const useMobileTabBarHeightMotionValue = () => {
    const tabBarHeight = useMotionValue(0);
    useEffect(() => {
        const element = getTarget(SCROLL_TO_TARGET_MOBILE_TAB_BAR);
        if (element) {
            tabBarHeight.set(element.clientHeight);
        }
    }, []);
    return tabBarHeight;
};
